import { Box, BoxProps } from "@chakra-ui/react";

export function ShieldIcon({
  color = "currentColor",
  ...props
}: BoxProps & { color?: string }) {
  return (
    <Box {...props} color={color}>
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.99858 1.66675C6.62402 1.66675 5.08435 3.34924 3.26346 3.9625C2.52307 4.21186 2.15287 4.33653 2.00305 4.51229C1.85324 4.68804 1.80936 4.94487 1.72162 5.45853C0.782711 10.9551 2.83492 16.0367 7.72918 18.0146C8.25504 18.2272 8.51797 18.3334 9.00117 18.3334C9.48437 18.3334 9.74728 18.2271 10.2731 18.0146C15.1671 16.0367 17.2173 10.9551 16.2781 5.45852C16.1904 4.94478 16.1465 4.68791 15.9966 4.51215C15.8468 4.3364 15.4766 4.21179 14.7363 3.96257C12.9146 3.34937 11.3732 1.66675 8.99858 1.66675Z"
          stroke="#1C00B8"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </Box>
  );
}

export default ShieldIcon;
